<div class="main-content">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <div class="container-fluid">
            <a class="navbar-brand" [routerLink]="['/home']">
                <img src="assets/img1.png" alt="" width="30" height="24" class="d-inline-block align-text-top">
                toDoList</a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarScroll"
                aria-controls="navbarScroll" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse main" id="navbarScroll">
                <ul class=" navbar-nav mt-2  ml-auto" style="--bs-scroll-height: 100px;">
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/login']">Login</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/signup']">Sign up</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    <div class="container">
        <div class="form-content">
            <form [formGroup]="passwordEditForm" (ngSubmit)="editUserPassword(passwordEditForm)">
                <div class="form-heading">
                    Reset Password
                </div>
                <div class="form-group">
                    <label for="passwordInput">Password</label>
                    <input type="password" class="form-control" [ngClass]="{
                        'has-danger': ((passwordEditForm.get('newPassword').invalid && passwordEditForm.get('newPassword').dirty)||(passwordEditForm.get('newPassword').touched && passwordEditForm.get('newPassword').pristine)), 
                        'has-success': passwordEditForm.get('newPassword').valid && passwordEditForm.get('newPassword').dirty
                      }" id="passwordInput" placeholder="Enter your new password" formControlName="newPassword"
                        data-toggle="tooltip" title="Minimum 8, Maximum 30 characters, atleast 1 number, 1
                        uppercase and 1 lowercase letter">
                </div>
                <div class="button-group">
                    <button type="submit" class="btn btn-success d-grid gap-2 col-sm-5 mx-auto"
                        [disabled]="!passwordEditForm.valid">Submit</button>
                </div>
            </form>
        </div>
    </div>
</div>